import { render, staticRenderFns } from "./Logotipos.vue?vue&type=template&id=ac0e1fd8"
import script from "./Logotipos.vue?vue&type=script&lang=js"
export * from "./Logotipos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports